import React from "react";
import PropTypes from "prop-types";
import TrendBadge from "components/Common/Badge/TrendBadge";
import ShimmerLoading from "components/Common/Shimmer";
import { getLastUpdatedDate } from "utils/dateUtils";

const StatsDetail = ({ value, title, change, details, testId, isLoading = false }) => {
  const renderShimmer = () => (
    <div>
      {title && <ShimmerLoading width={120} height={24} className="mb-2" />}
      <div className="d-flex justify-content-start align-items-center w-100 gap-3">
        <ShimmerLoading width={80} height={36} />
        <ShimmerLoading width={60} height={24} />
      </div>
      <ShimmerLoading width={100} height={18} className="mt-2" />
    </div>
  );

  const renderDetail = (detail, index) => {
    if (isLoading) {
      return renderShimmer();
    }

    return (
      <div key={`${testId}-detail-${index}`} data-testid={`${testId}-detail-${index}`}>
        {title && <h4 data-testid={`${testId}-detail-title-${index}`}>{detail.title}</h4>}
        <div className="d-flex justify-content-start align-items-center w-100 gap-3">
          <h1 className="mb-0 fw-semibold" data-testid={`${testId}-detail-value-${index}`}>
            {detail.value.toLocaleString("en-US", {})}
          </h1>
          <TrendBadge value={detail.change} data-testid={`${testId}-detail-trend-${index}`} />
        </div>
        <div className="text-md text-gray-400" data-testid={`${testId}-detail-update-${index}`}>
          อัพเดทเมื่อ {getLastUpdatedDate()}
        </div>
      </div>
    );
  };

  return (
    <div data-testid={`detail-stats-${testId}`}>
      {/** */}
      {isLoading ? renderShimmer() : details ? details.map((detail, index) => renderDetail(detail, index)) : renderDetail({ value, title, change }, 0)}
    </div>
  );
};

StatsDetail.propTypes = {
  value: PropTypes.number,
  title: PropTypes.string,
  change: PropTypes.number,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      change: PropTypes.number,
    })
  ),
  testId: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
};

export default StatsDetail;
